module.exports = __webpack_public_path__ + "static/media/SantaReliquiaCuadro-small.d1cfe44a.jpg";